import React, { useEffect, useMemo, useState } from "react";
import "./whats-new.css";
import mainimg from "../../Assets/png/mainimg.png";
import { apiCallAdmin } from "../../services/api-service";
import HtmlContent from "../common/html-content";
import arrowUp from "../../Assets/svg/arrow-up.svg";
import arrowDown from "../../Assets/svg/arrow-down.svg";
import { set } from "date-fns";

const WHATS_NEW_ENDPOINT = "whats_new/get_application_updates/28";
const WHATS_NEW_CATEGORIES_ENDPOINT = "whats_new/get_categories";
const ALL_UPDATES_CATEGORY = { value: "", label: "All Updates" };

const getUpdateKey = (sectionId, updateId) => `${sectionId}-${updateId}`;

const getUpdateChipClass = (value = "") => {
  const normalizedValue = value.toLowerCase();

  if (normalizedValue.includes("fix")) return "fix";
  if (normalizedValue.includes("major") || normalizedValue.includes("feature")) {
    return "new";
  }

  return "improved";
};

const getResponseList = (response) => {
  const data = response?.data?.suggestionlist;

  if (Array.isArray(data)) return data;
  /* if (Array.isArray(data?.categories)) return data.categories;
  if (Array.isArray(response?.data?.categories)) return response.data.categories; */

  return [];
};

const normalizeCategory = (category) => {
  const name =
    category?.name ??
    category?.category_name ??
    category?.category ??
    category?.label ??
    category?.title ??
    "";

  return {
    id:
      category?.id ??
      category?.category_id ??
      category?.value ??
      category?.key ??
      name,
    name,
  };
};

const WhatsNew = () => {
  const [latestBannerImage, setLatestBannerImage] = useState("");
  const [sections, setSections] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [activeCategoryId, setActiveCategoryId] = useState("");
  const [updateCategories, setUpdateCategories] = useState([
    ALL_UPDATES_CATEGORY,
  ]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let isMounted = true;

    const getApplicationUpdates = async () => {
      setLoading(true);
      setErrorMessage("");

      const response = await apiCallAdmin("get", WHATS_NEW_ENDPOINT, null, {
        params: {
          category_id: activeCategoryId,
          is_expected: true,
          application_id: 28,
          update_type_id: "",
          search: "",
        },
      });

      if (!isMounted) return;

      if (response?.data?.success) {
        setLatestBannerImage(response.data.banner_image || "");
        const nextSections = Array.isArray(response.data.data)
          ? response.data.data
          : [];

        setSections(nextSections);

        const firstSection = nextSections[0];
        const firstUpdate = firstSection?.updates?.[0];

        if (firstSection && firstUpdate) {
          setExpanded({
            [getUpdateKey(firstSection.section_id, firstUpdate.id)]: true,
          });
        }
      } else {
        setSections([]);
        setErrorMessage(
          response?.data?.message || "Unable to load application updates.",
        );
      }

      setLoading(false);
    };

    getApplicationUpdates();

    return () => {
      isMounted = false;
    };
  }, [activeCategoryId]);

  useEffect(() => {
    let isMounted = true;

    const getCategories = async () => {
      const response = await apiCallAdmin(
        "get",
        WHATS_NEW_CATEGORIES_ENDPOINT,
      );

      if (!isMounted || !response?.data?.success) return;

      const categoryData = getResponseList(response);
      /* const nextCategories = categoryData
        .map(normalizeCategory)
        .filter((category) => category.name); */

      setUpdateCategories([ALL_UPDATES_CATEGORY, ...categoryData]);
    };

    getCategories();

    return () => {
      isMounted = false;
    };
  }, []);

  const allUpdates = useMemo(() => {
    return sections.flatMap((section) =>
      (section.updates || []).map((update) => ({
        ...update,
        section_id: section.section_id,
        section_name: section.section_name,
      })),
    );
  }, [sections]);

  const latestUpdate = allUpdates[0];

  const handleToggle = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="whats-new-page">
      <div className="wn-shell">
        <div className="wn-title-block">
          <h1 className="wn-title">
            What&apos;s New in <span>TickGO</span>
          </h1>
          <p className="wn-subtitle">
            Smarter ticketing. Faster resolutions. Better control.
          </p>
        </div>
      </div>

      {latestBannerImage && (
        <div className="wn-banner">
          <img src={latestBannerImage} alt="Latest TickGO updates" />
        </div>
      )}

      <div className="wn-shell">
        {/* <article className="wn-highlight-card">
          <div>
            <span className="wn-pill">Latest Version</span>
            <h2 className="wn-highlight-title">
              {latestUpdate?.title || "Application Updates"}
            </h2>
            <p className="wn-highlight-copy">
              {latestUpdate
                ? `${latestUpdate.category || "Update"} release${
                    latestUpdate.release_date
                      ? ` on ${latestUpdate.release_date}`
                      : ""
                  }.`
                : "Stay current with the latest TickGO releases and improvements."}
            </p>

            <div className="wn-feature-list">
              {(latestUpdate?.tags?.length
                ? latestUpdate.tags
                : [
                    "Latest improvements",
                    "Feature enhancements",
                    "Better workflow",
                  ]
              ).map((tag, index) => (
                <div className="wn-feature-item" key={`${tag}-${index}`}>
                  <span className="wn-feature-icon">{index + 1}</span>
                  <span>{tag}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="wn-visual">
            <img src={mainimg} alt="TickGO updates preview" />
            <div className="wn-visual-chip top">Ticket Overview</div>
            <div className="wn-visual-chip bottom">In Progress Tickets</div>
          </div>
        </article> */}
        

        {updateCategories.length > 1 && (
          <div className="wn-filter-tabs" aria-label="update categories">
            {updateCategories.map((category) => {
              const isActive = activeCategoryId === category.value;

              return (
                <button
                  key={`${category.id}-${category.label}`}
                  className={`wn-filter-tab${isActive ? " active" : ""}`}
                  onClick={() => setActiveCategoryId(category.value)}
                  type="button"
                  aria-pressed={isActive}
                >
                  {category.label}
                </button>
              );
            })}
          </div>
        )}

        {loading && <div className="wn-state">Loading updates...</div>}

        {!loading && errorMessage && (
          <div className="wn-state error">{errorMessage}</div>
        )}

        {!loading && !errorMessage && sections.length === 0 && (
          <div className="wn-state">No updates found.</div>
        )}

        {!loading &&
          !errorMessage &&
          sections.map((section) => (
            <section key={section.section_id}>
              <h3 className="wn-year">
                {section.section_name || "Updates"}
              </h3>

              <div className="wn-release-list">
                {(section.updates || []).map((update) => {
                  const updateKey = getUpdateKey(section.section_id, update.id);
                  const isExpanded = expanded[updateKey];

                  return (
                    <article className="wn-release-card" key={update.id}>
                      <button
                        className="wn-release-header"
                        onClick={() => handleToggle(updateKey)}
                        type="button"
                        aria-expanded={isExpanded}
                      >
                        <div>
                          <div className="wn-release-title">
                            Version {update.version_name} - {update.title}{" "}
                            {update.update_type && (
                              <span
                                className={`wn-chip ${getUpdateChipClass(
                                  update.update_type,
                                )}`}
                              >
                                {update.update_type}
                              </span>
                            )}
                          </div>
                          <div className="wn-release-meta">
                            {update.release_date
                              ? `Released ${update.release_date}`
                              : "Release date unavailable"}
                          </div>
                          <div className="wn-chip-row">
                           {/*  {update.category && (
                              <span
                                className={`wn-chip ${getUpdateChipClass(
                                  update.category,
                                )}`}
                              >
                                {update.category}
                              </span>
                            )} */}
                            
                            {(update.tags || []).map((tag) => (
                              <span className="wn-chip-tag " key={tag}>
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>
                        <span className="wn-caret">
                          <img
                            src={isExpanded ? arrowUp : arrowDown}
                            alt="arrow"
                          />
                        </span>
                      </button>

                      {isExpanded && (
                        <div className="wn-release-body">
                          {/* <div className="wn-preview" /> */}
                          <div className="wn-detail-card wn-content-card">
                            <HtmlContent
                              html={
                                update.content ||
                                "<p>No content available.</p>"
                              }
                            />
                          </div>
                        </div>
                      )}
                    </article>
                  );
                })}
              </div>
            </section>
          ))}

        <section className="wn-cta">
          <h3>
            Experience the Latest <span>TickGO</span> Updates
          </h3>
          <p>
            Join over 10,000 teams transforming their ticketing workflow with
            our intelligent platform.
          </p>
          <div className="wn-cta-actions">
            <button className="wn-btn primary" type="button" onClick={()=>{
              window.open("https://mawalog.com/say-hello#contact-section", "_blank", "noopener,noreferrer");
            }}>
              Get Started Now
            </button>
            <button className="wn-btn dark" type="button" onClick={() => {
                window.open("https://outlook.office365.com/book/MawalogOne@lenteratechno.onmicrosoft.com/", "_blank", "noopener,noreferrer");
              }}>
              Schedule a Demo
            </button>
          </div>
        </section>
      </div>
    </section>
  );
};

export default WhatsNew;
